@if (ngControl.control != null) {
  <input
    test-selector="text-input"
    pInputText
    [autocomplete]="autocomplete"
    [placeholder]="placeholder"
    [name]="name"
    [formControl]="ngControl.control! | abstractControlToFormControl" />
}
